import React from 'react'
import { useTheme, useMediaQuery } from '@hermes/web-components'
import {
  CardContainer,
  TopContentSection,
  BottomContentSection,
  IntroSection,
  IntroDescriptionBox,
  DescriptionSection,
  RatingSection,
  KeywordsSection,
  EmptyButton,
  AvatarSkeleton,
  TopIntroTextSkeleton,
  BottomIntroTextSkeleton,
  TopDescriptionTextSkeleton,
  BottomDescriptionTextSkeleton,
  KeywordsTextSkeleton,
  KeywordSkeleton,
  RatingButton,
  StyledDivider
} from './styles'

type SectionProps = {
  isMobile: boolean
}

const IntroSectionComponent = () => (
  <IntroSection container>
    <AvatarSkeleton variant="rounded" />
    <IntroDescriptionBox>
      <TopIntroTextSkeleton variant="rounded" />
      <BottomIntroTextSkeleton variant="rounded" />
    </IntroDescriptionBox>
  </IntroSection>
)

const DescriptionSectionComponent = ({ isMobile }: SectionProps) => (
  <DescriptionSection>
    <TopDescriptionTextSkeleton variant="text" />
    <BottomDescriptionTextSkeleton variant="text" />
    {isMobile && <RatingButton variant="rounded" />}
  </DescriptionSection>
)

const KeywordsSectionComponent = ({ isMobile }: SectionProps) => (
  <KeywordsSection container>
    <KeywordsTextSkeleton variant="text" />
    <KeywordSkeleton variant="rounded" />
    <KeywordSkeleton variant="rounded" />
    {!isMobile && <KeywordSkeleton variant="rounded" />}
  </KeywordsSection>
)

const RatingSectionComponent = ({ isMobile }: SectionProps) => (
  <RatingSection container>
    {!isMobile ? <RatingButton variant="rounded" /> : <StyledDivider />}
    <EmptyButton />
  </RatingSection>
)

function SearchResultEmptyStateCard() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <CardContainer container>
      <TopContentSection>
        <IntroSectionComponent />
        <DescriptionSectionComponent isMobile={isMobile} />
        <KeywordsSectionComponent isMobile={isMobile} />
      </TopContentSection>
      <BottomContentSection>
        <RatingSectionComponent isMobile={isMobile} />
      </BottomContentSection>
    </CardContainer>
  )
}

export default SearchResultEmptyStateCard
